/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blank_FramesInputs */



/**
* | output |
* | --- |
* | "Blank Frames..." |
*
* @param {Blank_FramesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const blank_frames = /** @type {((inputs?: Blank_FramesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blank_FramesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Images vides...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Leere Rahmen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cornici vuote...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пустые рамки...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Marcos en blanco...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("空白相框……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("空白のフレーム...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खाली फ्रेम...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Molduras em branco...")
	return /** @type {LocalizedString} */ ("Blank Frames...")
});